import { Routes } from '@angular/router';
import { adminGuard } from '../../core/guards';
import { CATALOGUE_CONFIG } from '../catalogue/catalogue.types';
import { SCOPE_CATALOGUE } from './scope.config';

export const scopesRoutes: Routes = [
  {
    path: 'scopes',
    providers: [{ provide: CATALOGUE_CONFIG, useValue: SCOPE_CATALOGUE }],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../catalogue/catalogue-list/catalogue-list.component').then((m) => m.CatalogueListComponent),
      },
      {
        path: 'new',
        loadComponent: () =>
          import('./components/scope-create/scope-create.component').then((m) => m.ScopeCreateComponent),
        canActivate: [adminGuard],
      },
      {
        path: ':id',
        loadComponent: () =>
          import('../catalogue/catalogue-detail/catalogue-detail.component').then((m) => m.CatalogueDetailComponent),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./components/scope-edit/scope-edit.component').then((m) => m.ScopeEditComponent),
        canActivate: [adminGuard],
      },
    ],
  },
];
